import React from "react";

export const CrossMarkCircleIcon = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={50}
        height={50}
        viewBox="0 0 120 120"
        xmlSpace="preserve"
        {...props}
    >
        <desc>{"\n    Created with Fabric.js 3.5.0\n  "}</desc>
        <defs />
        <g transform="matrix(0.0868 0 0 0.0868 61.9459 61.9459)" id={708385}>
            <g style={{}}>
                <g transform="matrix(27.6559 0 0 27.6559 0.0004 0.0004)" id={130414}>
                    <circle
                        style={{
                            stroke: "none",
                            strokeWidth: 0,
                            strokeDasharray: "none",
                            strokeLinecap: "butt",
                            strokeDashoffset: 0,
                            strokeLinejoin: "miter",
                            strokeMiterlimit: 4,
                            isCustomFont: "none",
                            fontFileUrl: "none",
                            fill: "rgb(255,102,60)",
                            fillRule: "nonzero",
                            opacity: 1,
                        }}
                        vectorEffect="non-scaling-stroke"
                        cx={0}
                        cy={0}
                        r={17.5}
                    />
                </g>
                <g transform="matrix(1 0 0 1 0 0)" id={125973}>
                    <path
                        style={{
                            stroke: "none",
                            strokeWidth: 1,
                            strokeDasharray: "none",
                            strokeLinecap: "butt",
                            strokeDashoffset: 0,
                            strokeLinejoin: "miter",
                            strokeMiterlimit: 4,
                            isCustomFont: "none",
                            fontFileUrl: "none",
                            fill: "rgb(255,255,255)",
                            fillRule: "nonzero",
                            opacity: 1,
                        }}
                        vectorEffect="non-scaling-stroke"
                        transform=" translate(-11, -11)"
                        d="M 3.95159 0 L 0 3.95159 L 2.01783 5.96943 L 7.00637 11.042 L 2.01783 16.0306 L 0 17.9643 L 3.95159 22 L 5.96943 19.9822 L 11.042 14.9096 L 16.0306 19.9822 L 17.9643 22 L 22 17.9643 L 19.9822 16.0306 L 14.9096 11.042 L 19.9822 5.96943 L 22 3.95159 L 17.9643 0 L 16.0306 2.01783 L 11.042 7.00637 L 5.96943 2.01783 L 3.95159 0 Z"
                        strokeLinecap="round"
                    />
                </g>
                <g transform="matrix(30.9808 0 0 30.9808 0.0004 0.0004)" id={726623}>
                    <path
                        style={{
                            stroke: "none",
                            strokeWidth: 1,
                            strokeDasharray: "none",
                            strokeLinecap: "butt",
                            strokeDashoffset: 0,
                            strokeLinejoin: "miter",
                            strokeMiterlimit: 4,
                            isCustomFont: "none",
                            fontFileUrl: "none",
                            fill: "rgb(255,255,255)",
                            fillRule: "nonzero",
                            opacity: 1,
                        }}
                        vectorEffect="non-scaling-stroke"
                        transform=" translate(-11, -11)"
                        d="M 3.95159 0 L 0 3.95159 L 2.01783 5.96943 L 7.00637 11.042 L 2.01783 16.0306 L 0 17.9643 L 3.95159 22 L 5.96943 19.9822 L 11.042 14.9096 L 16.0306 19.9822 L 17.9643 22 L 22 17.9643 L 19.9822 16.0306 L 14.9096 11.042 L 19.9822 5.96943 L 22 3.95159 L 17.9643 0 L 16.0306 2.01783 L 11.042 7.00637 L 5.96943 2.01783 L 3.95159 0 Z"
                        strokeLinecap="round"
                    />
                </g>
            </g>
        </g>
    </svg>
);
